import { render } from "./eventList.vue?vue&type=template&id=899cbd02&ts=true"
import script from "./eventList.vue?vue&type=script&lang=ts&config=true"
export * from "./eventList.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__